import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';
import { useEffect } from 'react';
import CustomDrawingControls from './CustomDrawingControls';
import { ServiceAreaType } from '../constants';
import { useDrawingManager } from '../hooks/useDrawingManager';
import { UndoRedoControl } from './UndoRedoControl';

interface ExistingShape {
  type: ServiceAreaType;
  vertices?: [number, number][];
  centroid?: [number, number];
  range?: number;
  color: string;
}

interface DrawingWrapperProps {
  color?: string;
  onOverlayComplete?: (overlay: google.maps.Polygon | google.maps.Circle) => void;
  initialData?: {
    type: ServiceAreaType;
    vertices?: [number, number][];
    centroid?: [number, number];
    range?: number;
  };
  onOverlayClear?: () => void;
  existingShapes?: ExistingShape[];
  showExistingShapes?: boolean;
  onToggleExistingShapes?: (visible: boolean) => void;
  showControls?: boolean;
}

const DrawingWrapper = ({
  color,
  onOverlayComplete,
  initialData,
  onOverlayClear,
  existingShapes,
  showExistingShapes = true,
  showControls = true
}: DrawingWrapperProps) => {
  const { drawingManager, currentOverlay, clearCurrentOverlay, toggleExistingShapesVisibility } = useDrawingManager(
    color,
    onOverlayComplete,
    initialData,
    onOverlayClear,
    existingShapes
  );

  // Effect to handle visibility changes
  useEffect(() => {
    if (toggleExistingShapesVisibility) {
      toggleExistingShapesVisibility(showExistingShapes);
    }
  }, [showExistingShapes, toggleExistingShapesVisibility]);

  // Only render if we have a drawing manager
  if (!drawingManager) return null;

  return (
    <>
      {showControls && (
        <>
          <MapControl position={ControlPosition.TOP_RIGHT}>
            <CustomDrawingControls drawingManager={drawingManager} />
          </MapControl>
          <div
            className="absolute top-[54px] right-2 rounded-md border border-borderGray
           bg-white hover:border-secondary">
            <UndoRedoControl
              drawingManager={drawingManager}
              currentOverlay={currentOverlay}
              onClearOverlay={clearCurrentOverlay}
            />
          </div>
        </>
      )}
    </>
  );
};

export default DrawingWrapper;
